module.exports = __webpack_public_path__ + "static/media/spinach.1dd976e2.webp";